export default {"src":"/_next/static/media/injured-reserve.f92e2588.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};